import TypingEffect from './typing-effect';
import { Stack, Typography } from '@mui/material';


const MainSubheader = () => {
    return (
        <Stack direction={{xs: 'column', md: 'row' }} spacing={{ xs: 1, md: 0.5}} justifyContent='center' alignItems='center' sx={{ marginTop: '2rem'}}>
            <Typography variant='h2'><TypingEffect value={"SATURDAY"} delay={1.3} duration={.4}/></Typography>
            <Typography variant='h2'><TypingEffect value={"21st JUNE 2025"} delay={2} duration={.4}/></Typography>
        </Stack>
    )
}

export default MainSubheader;